<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="textTabsColor text-2xl font-bold" i18n="@@cartManagementTitle">Cart List</h1>
    <button
      (click)="openCreateCartDialog()"
      class="bgTabsColor hover-bg-primary-hover flex cursor-pointer items-center justify-center gap-1 rounded-[8px] px-[15px] py-[7px] text-[13px] font-bold text-white shadow-sm transition-all">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M18 12.998h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5v-5a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2" />
      </svg>
      <ng-container i18n="@@createNewCartBtn">Create New Cart</ng-container>
    </button>
  </div>

  <app-cart-list-filters
    [filters]="filters()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()"
    (toggleSortOrder)="onToggleSortOrder()" />

  <app-cart-list-table
    [carts]="carts()"
    [state]="state()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [totalItems]="totalItems()"
    [totalPages]="totalPages()"
    [isFiltersApplied]="isFiltersApplied()"
    [deleteError]="deleteError()"
    [deleteLoading]="deleteLoading()"
    [closeDeleteDialog]="closeDeleteDialog()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (retry)="loadCarts()"
    (rowClick)="viewCartDetails($event)"
    (deleteCart)="onDeleteCart($event)"
    (checkoutCart)="onCheckoutCart($event)" />

  @if (showCreateDialog()) {
    <app-create-cart-dialog (created)="onCartCreated($event)" (closed)="onCreateDialogClosed()" />
  }

  @if (deleteSuccess()) {
    <app-successful-notification
      type="success"
      [title]="isAr() ? 'تم حذف العربة بنجاح' : 'Cart deleted successfully'" />
  }
</div>

<!-- @if (unAuthorized()) {
  <app-confirmation-dialog
    [title]="isAr() ? 'انتهت صلاحية تسجيل الدخول' : 'login expired'"
    [description]="isAr() ? 'يرجى تسجيل الدخول مرة أخرى!' : 'please login again!'"
    [confirmContent]="isAr() ? 'سجل الدخول' : 'login'"
    (onSubmit)="redirectToLogin()">
  </app-confirmation-dialog>
} -->
